import { SplitOrderMethodEnum } from '../types/transaction';

export const orderMaxLot = 50000;
export const orderMaxQuantity = 50;

export const SPLIT_ORDER_COPY = {
  [SplitOrderMethodEnum.UNSPECIFIED]: 'Unspecified',
  [SplitOrderMethodEnum.EQUAL]: 'Equal',
  [SplitOrderMethodEnum.RANDOM]: 'Random',
};
